import { GenreDetailsOut, LibraryCreatedProductOut } from '../../../../../store/apiLibx';
import { TFunction } from 'i18next';

export const mapGenres = (product: LibraryCreatedProductOut | undefined, t: TFunction) => {
    const localGenresList = product?.genres?.filter(genre => genre.localGenre);
    const standardGenresList = product?.genres?.filter(genre => !genre.localGenre);

    const flatMapGenres = (genres: GenreDetailsOut[] | undefined) =>
        genres?.flatMap(genreObject => {
            if (genreObject.subGenres && genreObject.subGenres.length > 0) {
                return genreObject.subGenres.map(subGenreObject => ({
                    id: `${genreObject.id}->${subGenreObject.id}`,
                    name: t(`yourLocalContent.yourTitles.genreConcat`, {
                        genre: genreObject.name,
                        subGenre: subGenreObject.name
                    })
                }));
            }
            return { id: genreObject.id, name: genreObject.name };
        });

    return {
        localGenres: flatMapGenres(localGenresList) ?? [],
        standardGenres: flatMapGenres(standardGenresList) ?? []
    };
};
